import {globals} from "../modules/globals.js";
import {tutorialSteps} from "../data/tutorial.js";

let currentTutorialSteps;

function runTutorialState(stateName) {
	if (stateName === 'end_tutorial') {
		// If tutorial ended, remove tutorial elements, enable pointer events
		$('.tutorial-element-outline').hide();
		$('.tutorial-info-container').hide();
		globals.currentTutorialStep = null;
		enableTutorialPointerEvents();
		globals.game.story = null;
	}
	else {
		// Get steps for this tutorial state, run first step
		currentTutorialSteps = tutorialSteps[stateName];

		// Top menu button steps if not at that position
		if (['simulate_match', 'end_first_event', 'play_second_event_second_segment', 'play_second_event_main_event',
			'end_second_event'].indexOf(stateName) >= 0 && !$('#event-match-results').is(':visible') && currentTutorialSteps[0]['action'] !== 'click_play_event') {
			currentTutorialSteps.unshift({
				'text': "Click <span class=\"tutorial-color\">Play</span>.",
				'element': '#play-event',
				'action': 'click_play_event'
			})
		}
		if (['add_tag_match'].indexOf(stateName) >= 0 && !$('#booking-container').is(':visible') && currentTutorialSteps[0]['action'] !== 'click_book_button') {
			currentTutorialSteps.unshift({
				'text': "Click <span class=\"tutorial-color\">Book</span>.",
				'element': '#book-menu-button',
				'action': 'click_book_button'
			})
		}
		if (['book_singles_segment', 'book_feud_match'].indexOf(stateName) >= 0 && !$('#booking-container').is(':visible') && currentTutorialSteps[0]['action'] !== 'click_book_segment_button') {
			currentTutorialSteps.unshift({
				'text': "Click <span class=\"tutorial-color\">Book</span>.",
				'element': '#book-menu-button',
				'action': 'click_book_segment_button'
			})
		}
		if (['add_team'].indexOf(stateName) >= 0 && $('#main-menu-right').is(':empty') && currentTutorialSteps[0]['action'] !== 'click_view_teams') {
			currentTutorialSteps.unshift({
				'text': "Click <span class=\"tutorial-color\">Roster</span> and select <span class=\"tutorial-color\">Teams</span>.",
				'element': '#manage-roster', 'action': 'click_view_teams', 'subElements': ['#view-teams-menu-button']
			})
		}
		if (['disband_team', 'add_team', 'add_feud', 'view_indies', 'view_staff_and_facilities', 'add_gimmick_match',
			'other_features'].indexOf(stateName) >= 0 && $('#main-menu-right').is(':empty') && currentTutorialSteps[0]['action'] !== 'click_manage_button') {
			currentTutorialSteps.unshift({
				'text': "Click <span class=\"tutorial-color\">Manage</span>.",
				'element': '#manage',
				'action': 'click_manage_button'
			})
		}

		// Set multi match button setting
		if (stateName === 'add_vacant_title_match' && $('#multi-match-button').hasClass('selected')) {
			$('#multi-match-button').trigger('click')
		}
		if (['add_singles_match', 'add_tag_match'].indexOf(stateName) >= 0 && $('#multi-match-button').hasClass('selected')) {
			$('#multi-match-button').trigger('click')
		}

		globals.currentTutorialStep = currentTutorialSteps[0];
		runTutorialStep(globals.currentTutorialStep);
	}
}

function runTutorialStep(tutorialStep) {
    highlightTutorialElement(tutorialStep['element']);
    showTutorialText(tutorialStep['text'], tutorialStep['action'], tutorialStep['element'], tutorialStep['position']);
    disableTutorialPointerEvents(tutorialStep);
    scrollToTutorialContainer(tutorialStep);
}

function highlightTutorialElement(element) {
    let tutorialOutlineContainer = $('.tutorial-element-outline');
    tutorialOutlineContainer.hide();

    if (element) {

        // Scroll parent to element
        if ($(element).parent().is($('#segment-items-container')) || $(element).parent().is($('.message-preview-container'))) {
            let $container = $(element).parent(),
                $scrollTo = $(element);
            $container.scrollTop(
                $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
            );
        }

        let pos = $(element).eq(0).offset();
        if (pos) {
            tutorialOutlineContainer.show();
            let elementWidth = $(element).innerWidth();
            let elementHeight = $(element).innerHeight();
            // Adjust outline for some smaller elements
            if ($(element).is('.roster-member-alignment, .roster-member-status, .roster-member-overness, ' +
                '.roster-member-morale, .roster-member, .superstar-info-popularity, .superstar-info-workrate, ' +
                '.superstar-info-charisma, .match-feud-name, .match-result-feuds')) {
                elementHeight -= 6
            }
            tutorialOutlineContainer.css({
                top: pos.top - 8,
                left: pos.left - 8,
                width: elementWidth + 16,
                height: elementHeight + 16
            });
        }
    }
}

function showTutorialText(text, action, element, position) {
    let tutorialInfoContainer = $('.tutorial-info-container');
    $('.tutorial-info-text').html(text);

    // Show continue button if no action associated with this step
    if (!action) {
        $('.tutorial-info-continue-button').show();
    }
    else {
        $('.tutorial-info-continue-button').hide();
    }

    // Position tutorial container relative to element if present
    tutorialInfoContainer.show();
    if (element && $(element).length > 0) {
        let pos = $(element).eq(0).offset();
        if (pos) {
            let topPos = pos.top - tutorialInfoContainer.height() - 10;
            if (topPos < 0 || position === 'bottom') {
                // If above window, place below element
                topPos = pos.top + $(element).outerHeight() + 10;
            }
            let leftPos = pos.left;
            if (leftPos + tutorialInfoContainer.width() >= $(window).width()) {
                // If overflowing to the right, move to right edge
                leftPos -= ((leftPos + tutorialInfoContainer.width()) - $(window).width()) + 10
            }
            tutorialInfoContainer.css({top: topPos, left: leftPos});
        }
    }
    else {
        // Default position
        tutorialInfoContainer.css({top: '5%', left: (($(window).width() - tutorialInfoContainer.outerWidth()) / 2)});
    }

    // Force DOM refresh
    tutorialInfoContainer.hide().show(0);

    // Go to next step upon pressing continue
    $('.tutorial-info-continue-button').off('click');
    $('.tutorial-info-continue-button').on('click', function () {
        goToNextTutorialStep()
    });
}

function scrollToTutorialContainer(tutorialStep) {
    let tutorialInfoContainer = $('.tutorial-info-container');
    let tutorialOutlineContainer = $('.tutorial-element-outline');

    // Set where to scroll to (start aligns to top, end aligns to bottom)
    let blockValue;
    if (tutorialStep['scrollTo']) {
        blockValue = tutorialStep['scrollTo']
    }
    else {
        blockValue = ($('.container').css('width') === '480px') ? "start" : "end";
    }

    setTimeout(function () {
		let containerToScrollTo;
        // On mobile, scroll to outline container if it is visible and higher than info container
        if (blockValue === 'start' && tutorialOutlineContainer.is(':visible') && tutorialOutlineContainer.offset().top < tutorialInfoContainer.offset().top) {
            containerToScrollTo = tutorialOutlineContainer;
        }
        // On desktop, scroll to outline container if it is visible and lower than info container, if it is an action
        else if (tutorialStep['action'] && blockValue === 'end' && tutorialOutlineContainer.is(':visible') && tutorialOutlineContainer.offset().top > tutorialInfoContainer.offset().top) {
            containerToScrollTo = tutorialOutlineContainer;
        }
        else {
            containerToScrollTo = tutorialInfoContainer;
        }
        containerToScrollTo[0].scrollIntoView({behavior: "smooth", block: blockValue});
    }, 50);
}

function disableTutorialPointerEvents(tutorialStep) {
    if (tutorialStep) {
        $(".main-menu li:not(#main-menu-button), #booking-container .button, #booking-talent-menu input, #booking-talent-menu select, #booking-container .roster-item-member, " +
            ".main-menu .dropdown-menu li, .event-card-match-edit-menu .dropdown-menu li, .tag-match-option, #messages, #match .match-wrestler, #match .button, #event-updates .button, " +
            "#continue, #game-messages .button, .delete-message, #booking-container .feud-container, #booking-container .segment-item-container," +
            "#add-segment-item-menu input, #roster-container .button, #roster-container input, #roster-container select, " +
            "#roster-container .roster-member, #roster-member-details .button, #view-teams-container .button, #view-teams-container select, " +
            "#view-teams-container .view-teams-item, #add-team select, #add-team input, #add-team .button, #select-gimmick-match-container .gimmick-match-item, " +
            ".match-finishes-container .match-finishes-item-container, .viewership-results-box .button, #event-history-container .button, " +
            "#event-history-container select, #next-event, #last-event, #feud-history-container .button, #feud-history-container select, " +
            "#feud-history-container .feud-history-item, #feud-history-container input, .feuds-history-sort-order, #create-feud .button, #create-feud input, " +
            "#create-feud select, #create-feud .feud-item-container, #indie .roster-member, #indie input, " +
            ".company-staff-container .button, .company-staff-container .company-staff-member, .company-facilities-container .button, " +
            ".staff-member-details .button, #view-gimmick-matches-container .button, #add-gimmick-match .button, #add-gimmick-match input, " +
            "#add-gimmick-match select, #matches .button, #matches .event-match, #feud-items-container .feud-item-container").css("pointer-events", "none");
        if (tutorialStep['element'] && !tutorialStep['disallowClick']) {
            $(tutorialStep['element']).eq(0).css("pointer-events", "auto");
            if ($(tutorialStep['element']).eq(0).is('input, select')) {
                $(tutorialStep['element']).eq(0).focus()
            }
        }
        if (tutorialStep['subElements']) {
            tutorialStep['subElements'].forEach(function (subElement) {
                $(subElement).eq(0).css("pointer-events", "auto")
            });
        }
    }
}

function enableTutorialPointerEvents() {
    if ($(".main-menu li:not(#main-menu-button)").css("pointer-events") === "none") {
        $(".main-menu li:not(#main-menu-button), #booking-container .button, #booking-talent-menu input, #booking-talent-menu select, #booking-container .roster-item-member, " +
            ".main-menu .dropdown-menu li, .event-card-match-edit-menu .dropdown-menu li, .tag-match-option, #messages, #match .match-wrestler, #match .button, #event-updates .button, " +
            "#continue, #game-messages .button, .delete-message, #booking-container .feud-container, #booking-container .segment-item-container," +
            "#add-segment-item-menu input, #roster-container .button, #roster-container input, #roster-container select, " +
            "#roster-container .roster-member, #roster-member-details .button, #view-teams-container .button, #view-teams-container select, " +
            "#view-teams-container .view-teams-item, #add-team select, #add-team input, #add-team .button, #select-gimmick-match-container .gimmick-match-item, " +
            ".match-finishes-container .match-finishes-item-container, .viewership-results-box .button, #event-history-container .button, " +
            "#event-history-container select, #next-event, #last-event, #feud-history-container .button, #feud-history-container select, " +
            "#feud-history-container .feud-history-item, #feud-history-container input, .feuds-history-sort-order, #create-feud .button, #create-feud input, " +
            "#create-feud select, #create-feud .feud-item-container, #indie .roster-member, #indie input, " +
            ".company-staff-container .button, .company-staff-container .company-staff-member, .company-facilities-container .button, " +
            ".staff-member-details .button, #view-gimmick-matches-container .button, #add-gimmick-match .button, #add-gimmick-match input, " +
            "#add-gimmick-match select, #matches .button, #matches .event-match, #feud-items-container .feud-item-container").css("pointer-events", "auto");
    }
}

function goToNextTutorialStep() {
    // Check if next step exists
    let tutorialStepIndex = currentTutorialSteps.indexOf(globals.currentTutorialStep);
    if (tutorialStepIndex + 1 < currentTutorialSteps.length) {
        // Set next tutorial step and run it
        globals.currentTutorialStep = currentTutorialSteps[tutorialStepIndex + 1];
        runTutorialStep(globals.currentTutorialStep);
    }
    else {
        // Run next tutorial state
        runTutorialState(globals.game.tutorialState);
    }
}

function checkTutorialStepAction(performedAction) {
    // Check if current tutorial step's action matches the performed action
    if (globals.currentTutorialStep && globals.currentTutorialStep['action'] === performedAction) {
        goToNextTutorialStep()
    }
}

export {runTutorialState, checkTutorialStepAction, disableTutorialPointerEvents, enableTutorialPointerEvents}